import React from 'react';

const RISK_COLORS = {
  low: { stroke: '#22c55e', bg: 'text-green-500', label: 'lowRisk' },
  medium: { stroke: '#eab308', bg: 'text-yellow-500', label: 'mediumRisk' },
  high: { stroke: '#f97316', bg: 'text-orange-500', label: 'highRisk' },
  critical: { stroke: '#ef4444', bg: 'text-red-500', label: 'criticalRisk' },
  unknown: { stroke: '#94a3b8', bg: 'text-slate-400', label: 'unknown' },
};

function RiskGauge({ score, riskLevel, t, size = 180 }) {
  const level = RISK_COLORS[riskLevel] || RISK_COLORS.unknown;
  const numericScore = score === null || score === undefined || score === 'unknown' ? null : Number(score);
  const displayScore = numericScore === null || Number.isNaN(numericScore) ? '—' : Math.round(numericScore);
  const progress = numericScore === null || Number.isNaN(numericScore) ? 0 : Math.min(100, Math.max(0, numericScore));

  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  const center = size / 2;

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="transform -rotate-90">
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="currentColor"
            strokeWidth="12"
            className="text-gray-200 dark:text-gray-700"
          />
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={level.stroke}
            strokeWidth="12"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className="transition-all duration-700 ease-out"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`text-4xl font-bold ${level.bg}`}>{displayScore}</span>
          <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">{t('points')}</span>
        </div>
      </div>
      <p className={`mt-3 text-sm font-semibold ${level.bg}`}>
        {t(level.label)}
      </p>
    </div>
  );
}

export default RiskGauge;
